import { HttpUrlEncodingCodec } from '@angular/common/http';

// https://www.moritz-benzenhoefer.com/2018/01/angular-http-requests-use-square-brackets-in-httpparams-as-parameter-key-name/

export class CustomListApiHttpUrlEncodingCodec extends HttpUrlEncodingCodec {
	encodeValue(k: string): string {
		return super.encodeValue(k).replace(/\+/g, "%2B");		
	}
} 